export const GIF_MESSAGE_QUERY_KEY = "GifMessage";
export const MESSAGE_LIST_STATE_KEY = "MessageList-virtualized-state";
